import Axios from 'axios';
import * as AccountRequest from '@/models/accountRequest';
import * as AccountResponse from '@/models/accountResponse';

export type Account = AccountResponse.TutorAccountDetailResponse;

export interface PasswordInfo {
  oldPassword: string;
  newPassword: string;
  confirmPassword: string;
}

interface State {
  loading: boolean;
  user: Account | null;
}
const mapState: State = {
  loading: false,
  user: null,
};

const mapActions = {
  async fetchMyData({ commit }: any) {
    commit('setLoading', true);

    const response = await Axios.post('/api/Account/MyData').catch((error) => {
      commit('setLoading', false);
      throw error;
    });
    commit('setMyData', response.data);
  },
  async changePassword({ commit }: any, { id, passwordInfo }: { id: string, passwordInfo: PasswordInfo }) {
    if (passwordInfo.newPassword !== passwordInfo.confirmPassword) {
      throw new Error('新しいパスワードとパスワード（確認）が一致していません。');
    }
    if (passwordInfo.oldPassword === passwordInfo.newPassword) {
      throw new Error('同じパスワードは使用できません。');
    }
    const request: AccountRequest.PasswordChangeRequest = {
      id,
      oldPassword: passwordInfo.oldPassword,
      newPassword: passwordInfo.newPassword,
    };
    await Axios.post('/api/Account/PasswordChange', request).catch((error) => {
      throw new Error('パスワード変更に失敗しました。');
    });
  },
};

const mapMutations = {
  setLoading(state: State, loading: boolean) {
    state.loading = loading;
  },
  setMyData(state: State, user: AccountResponse.TutorAccountDetailResponse) {
    state.user = user;
    state.loading = false;
  },
};

export default {
  namespaced: true,
  state: mapState,
  actions: mapActions,
  mutations: mapMutations,
};
